import { render } from "./EstoqueOleo.vue?vue&type=template&id=864e68ea&scoped=true"
import script from "./EstoqueOleo.vue?vue&type=script&lang=js"
export * from "./EstoqueOleo.vue?vue&type=script&lang=js"

import "./EstoqueOleo.vue?vue&type=style&index=0&id=864e68ea&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-864e68ea"]])

export default __exports__